export class FileFormatHeader {
	private static fileFormatHeaders: any = {
		pdf: 'application/pdf;charset=UTF-8',
		xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
	};

	public static getCorrespondingAcceptHeaderValue(fileType: string) {
		return this.fileFormatHeaders[fileType];
	}
}
